// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wl-provinces-cascader-popper .el-cascader-menu__wrap el-scrollbar__wrap {\n  overflow: overlay;\n}\n", ""]);
// Exports
module.exports = exports;
